import axios from "axios";
import React, { useEffect, useState } from "react";
import Cookies from "universal-cookie";
import CreaEquipoAmbulatorio from "./CreaEquipos/CreaEquipoAmbulatorio";
import DequipoCirugiaAmbulatoria from "../../EliminaEquipos/DequipoCirugiaAmbulatoria";

function EquipoAmbulatorio({ idSolicitud }) {
  const cookies = new Cookies();
  const [list, setList] = useState([]);

  useEffect(() => {
    obtenerEquipos();
  }, [idSolicitud]);

  const obtenerEquipos = async () => {
    try {
      const res = await axios({
        method: "get",
        auth: {
          username: "BasicAuth@icontec.org",
          password: "yQLzqmR7eZSuAmQZUqhY",
        },
        url:
          "https://suadesarrollo.azurewebsites.net/api/ObtenerEquipoAmbulatorioPorSolicitudId?SolicitudId=" +
          idSolicitud,
      });
      setList(res.data || []);
    } catch (error) {
      console.error(error);
    }
  };

  const handleDelete = (id) => {
    setList((prev) => prev.filter((item) => item.id !== id));
  };

  const url = window.location.href;
  const partesURL = url.split("/");
  const nombreRuta = partesURL[partesURL.indexOf("#") + 1];

  return (
    <div className="container">
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          <h6 className="m-0 font-weight-bold text-primary">
            2. EQUIPO DE AUTOEVALUACIÓN DE SERVICIOS AMBULATORIOS
          </h6>
        </div>

        <div className="card-body">
          {cookies.get("tipo_Usuario") == 2 &&
            nombreRuta === "ProcesoAutoevaluacion" && (
              <CreaEquipoAmbulatorio
                idSolicitud={idSolicitud}
                onCreated={obtenerEquipos}
              />
            )}

          <div className="table-responsive mt-3">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Id</th>
                  <th>Nombre</th>
                  <th>Área</th>
                  <th>Cargo</th>
                  <th>Líder</th>
                  {nombreRuta === "ProcesoAutoevaluacion" && <th>Eliminar</th>}
                </tr>
              </thead>

              <tbody>
                {list.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="text-center text-muted">
                      No hay registros
                    </td>
                  </tr>
                ) : (
                  list.map((item) => (
                    <tr key={item.id}>
                      <td>{item.id}</td>
                      <td>{item.nombre}</td>
                      <td>{item.area}</td>
                      <td>{item.cargo}</td>
                      <td>{item.lider}</td>
                      {nombreRuta === "ProcesoAutoevaluacion" && (
                        <td>
                          <DequipoCirugiaAmbulatoria
                            id={item.id}
                            onDelete={handleDelete}
                          />
                        </td>
                      )}
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EquipoAmbulatorio;
